var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgInfoIconRed = function SvgInfoIconRed(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104.88 113.66",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#E03030;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "comunicacion"
  }, /*#__PURE__*/React.createElement("g", {
    id: "info"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 46.86,
    y: 43.59,
    width: 11.1,
    height: 41.87
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52.41,27.45h-.1a5.83,5.83,0,0,0-5.86,5.78.28.28,0,0,0,0,.09A5.84,5.84,0,0,0,52.41,39h.4a5.8,5.8,0,1,0-.4-11.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52.44,6.13a50.7,50.7,0,1,0,50.7,50.7A50.76,50.76,0,0,0,52.44,6.13Zm0,97.4a46.7,46.7,0,1,1,46.7-46.7A46.75,46.75,0,0,1,52.44,103.53Z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgInfoIconRed);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "info-icon-red.7cad398fd604addcdb4def0bf8014c5f.svg";